module.exports = __webpack_public_path__ + "img/IMG_8155_L_Wood_MockedUp.18e614f0.jpg";